import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";

import { CityInput } from "types";
import { Input } from "@/components/ui/input";
import { useFormContext } from "react-hook-form";

const EMAIL_PATTERN = /^[\w.+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
const EMAIL_OR_DOMAIN_PATTERN = /^(?:[\w.+-]+@)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;

// The two fields form one configuration: either none or both are filled
const requiredWhenAnyFilled = (value: string | undefined, formValues: CityInput) => {
  const decreeAnalysis = formValues.options?.decreeAnalysis;
  const anyFilled = !!(decreeAnalysis?.emailFrom?.trim() || decreeAnalysis?.emailTo?.trim());
  return !anyFilled || !!value?.trim() || "Champ requis";
};

export const DecreeAnalysisEmailConfig = () => {
  const { control } = useFormContext<CityInput>();

  return (
    <div className="w-full flex flex-col mt-6">
      <h1 className="font-bold text-sm mb-2">Emails des arrêtés</h1>
      <div className="grid grid-cols-1 gap-4">
        <FormField
          control={control}
          name="options.decreeAnalysis.emailFrom"
          rules={{
            validate: requiredWhenAnyFilled,
            pattern: {
              value: EMAIL_OR_DOMAIN_PATTERN,
              message: "Domaine ou adresse email invalide.",
            },
          }}
          render={({ field: { value, ...rest } }) => (
            <FormItem>
              <FormLabel>Email expéditeur (domaine ou adresse de la ville)</FormLabel>
              <FormControl>
                <Input value={value ?? ""} {...rest} placeholder="ville-courbevoie.fr" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="options.decreeAnalysis.emailTo"
          rules={{
            validate: requiredWhenAnyFilled,
            pattern: {
              value: EMAIL_PATTERN,
              message: "Adresse email invalide.",
            },
          }}
          render={({ field: { value, ...rest } }) => (
            <FormItem>
              <FormLabel>Email destinataire (adresse de réception des arrêtés)</FormLabel>
              <FormControl>
                <Input value={value ?? ""} {...rest} placeholder="courbevoie@macaron.ai" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
